import React from 'react';
import clsx from 'clsx';
import { FieldProps } from 'formik';
import sanitizer from '@helpers/sanitizer';
import styles from '../form.module.scss';

const InputComponent: React.FC<
  {
    label: string;
    placeholder: string;
    type: string;
    required?: boolean;
    handleSendTracking?: () => void;
    children?: React.ReactNode;
    id?: string;
    options?: { name: string; id: string; value: string }[];
    value?: string;
  } & FieldProps
> = (props) => {
  const { id, field, form, meta, label, required, handleSendTracking, children, ...rest } = props;
  switch (rest.type) {
    case 'select':
      return (
        <div className={clsx('vc-formUnit', 'vc-formUnit--select', meta.error && 'error')}>
          <select
            {...field}
            {...rest}
            id={field.name}
            className={clsx('vc-inputText', meta.error && 'error')}
            onBlur={handleSendTracking}
            required={required}
            onFocus={() => form.setFieldTouched(field.name, true)}
          >
            <option value="">Choose</option>
            {rest.options.map((option) => (
              <option
                key={option.id}
                value={option.value}
              >
                {option.name}
              </option>
            ))}
          </select>
          <label
            htmlFor={field.name}
            className={clsx('vc-inputText-label', required && 'vc-inputText-label--required')}
            dangerouslySetInnerHTML={{ __html: sanitizer(label) }}
          />
        </div>
      );
    case 'textarea':
      return (
        <div className={clsx('vc-formUnit', styles.proSellersForm__form__row, meta.error && meta.touched && 'error')}>
          <textarea
            {...field}
            {...rest}
            id={field.name}
            className={clsx('vc-inputText', meta.error && 'error')}
            onBlur={handleSendTracking}
            required={required}
            onFocus={() => form.setFieldTouched(field.name, true)}
          />
          <label
            htmlFor={field.name}
            className={clsx('vc-inputText-label', required && 'vc-inputText-label--required')}
            dangerouslySetInnerHTML={{ __html: sanitizer(label) }}
          />
          {children}
        </div>
      );
    case 'checkbox':
      return (
        <div className={clsx(styles.proSellerForm__form__row)}>
          <div className={clsx('vc-formUnit', meta.error && meta.touched && 'error')}>
            <input
              {...field}
              {...rest}
              id={field.name}
              name={field.name}
              type="checkbox"
              className={clsx('vc-checkbox__input')}
              onBlur={handleSendTracking}
              required={required}
              onFocus={() => form.setFieldTouched(field.name, true)}
            />
            <label
              htmlFor={field.name}
              className={clsx('vc-checkbox__label', 'vc-text-m')}
              dangerouslySetInnerHTML={{ __html: sanitizer(label) }}
            />
            {children}
          </div>
        </div>
      );
    case 'checkbox_group':
      return (
        <>
          <input
            {...field}
            {...rest}
            id={id}
            name={field.name}
            type="checkbox"
            className={clsx('vc-checkbox__input')}
            onBlur={handleSendTracking}
            required={required}
            onFocus={() => form.setFieldTouched(field.name, true)}
            value={rest.value}
            checked={form.values[field.name].includes(rest.value)}
            onChange={(e) => {
              if (e.target.checked) {
                form.setFieldValue(field.name, Array.from(new Set([...form.values[field.name], rest.value])));
                return;
              }
              form.setFieldValue(
                field.name,
                form.values[field.name].filter((value) => value !== rest.value),
              );
            }}
          />
          <label
            htmlFor={id}
            className={clsx('vc-checkbox__label')}
            dangerouslySetInnerHTML={{ __html: sanitizer(label) }}
          />
          {children}
        </>
      );
    default:
      return (
        <div className={clsx('vc-formUnit', styles.proSellersForm__form__row, meta.error && meta.touched && 'error')}>
          <input
            {...field}
            {...rest}
            id={field.name}
            className={clsx('vc-inputText', meta.error && 'error')}
            onBlur={handleSendTracking}
            required={required}
            onFocus={() => form.setFieldTouched(field.name, true)}
          />
          <label
            htmlFor={field.name}
            className={clsx('vc-inputText-label', required && 'vc-inputText-label--required')}
            dangerouslySetInnerHTML={{ __html: sanitizer(label) }}
          />
          {children}
        </div>
      );
  }
};

export default InputComponent;
